const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./account/common'));
    processInclude(require('./ibcsearch/ibcsearch'));
});